import { Group } from '@gripp/shared-logic';
import { Platform, StyleSheet, View } from 'react-native';
import { GroupChip } from './groupChip';
import { GroupChipMenu } from './groupChipMenu';

export const getGroupColumn = (
  info: any,
  onPress: (groupId: string) => Promise<void>,
  disabled = false
) => {
  const groups = info.getValue() as Group[];
  const isWeb = Platform.OS === 'web';

  if (!groups || groups.length === 0) return null;

  const onGroupPress = !disabled ? onPress : undefined;
  const firstGroup = (
    <GroupChip
      group={groups[0]}
      additionalStyle={[
        (isWeb && groups.length === 1) || !isWeb
          ? styles.firstGroupChipOnly
          : styles.firstGroupChip,
        { alignSelf: 'flex-start' },
      ]}
      onPress={onGroupPress}
    />
  );

  const secondGroup = groups[1] ? (
    <GroupChip
      group={groups[1]}
      additionalStyle={styles.firstGroupChipOnly}
      onPress={onGroupPress}
    />
  ) : null;

  const groupMenu = (
    <GroupChipMenu
      groups={groups}
      onPress={onGroupPress}
      chipLength={!isWeb && groups.length > 2 ? groups.length - 1 : undefined}
    />
  );

  if (groups.length === 1) {
    return <View>{firstGroup}</View>;
  }

  if (isWeb) {
    return (
      <View style={{ flex: 1, flexDirection: 'row', gap: 1 }}>
        {firstGroup}
        {groupMenu}
      </View>
    );
  }

  if (groups.length === 2) {
    return (
      <View style={{ flexDirection: 'column', gap: 4 }}>
        {firstGroup}
        {secondGroup}
      </View>
    );
  }

  return (
    <View style={{ gap: 4 }}>
      {firstGroup}
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
        <View style={{ maxWidth: 100 }}>{secondGroup}</View>
        {groupMenu}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  firstGroupChip: {
    marginRight: 5,
    maxWidth: '70%',
  },
  firstGroupChipOnly: {
    marginRight: 5,
    maxWidth: '100%',
  },
});
